import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import React from 'react'
import { Provider } from 'react-redux'
import theme from './init/theme'
import ErrorMessageProvider from './libs/ErrorMessageProvider'
import store from '@reducers/store'

export default function AppContext({ children }: { children: React.ReactElement }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ErrorMessageProvider>{children}</ErrorMessageProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
